module.exports = __webpack_public_path__ + "media/images/tutorial_header_sp1-02-adcecf98d10048070b9c83d6bd446146.png";